import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { FaSearch } from "react-icons/fa";
import TextField from '@mui/material/TextField';
import { ApiLink } from '../../APILink/ApiLink';
import authHeader from '../../Auth/authHeader';
import { errorAlert } from '../../Components/Alerts';
import Autocomplete from "@mui/material/Autocomplete";
import SupplierDetails from './Details/SupplierDetails';
import '../../Style/Kartela.scss';

export default function KartelaFurnitorit(props) {
    const headers = authHeader();

    const [supplier, setSupplier] = useState([]);
    const [supplierID, setSupplierID] = useState(0)
    const [nui, setNUI] = useState("");

    const [openDetails, setOpenDetails] = useState(false); // Deklarimi i useState


    const [accField, setAccfield] = useState(null)
    const [accName, setAccName] = useState(null)

    const handleAutocompleteChangeSupplier = (event, value) => {
        if (value && value.AccountID) {
            setSupplierID(value.AccountID);
            setAccfield(value);
            setAccName(value.AccountName);
            setNUI(value.IdentificationNumber);
        } else {
            // Në rast se vlera është pastruar
            setSupplierID(""); // Vendos vlerën e ArticleID në null
        }
    };

    const defaultPropsSupplier = {
        options: supplier,
        getOptionLabel: (option) =>
            `${option.IdentificationNumber} - ${option.AccountName}` || "",
        renderOption: (props, option) => (
            <>
                <li {...props} style={{ borderBottom: "1px solid lightgray" }}>
                    <span>
                        {option.IdentificationNumber}<br />
                        {option.AccountName}
                    </span>
                </li>
            </>
        ),
    };

    const showCard = () => {
        if (supplierID != 0) {
            setOpenDetails(true);
        }
        else {
            setOpenDetails(false);
            errorAlert("Ju lutem zgjedhni furnitorin")
        }
    }

    const fetchSupplier = async () => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'Accounts/accountByLedger', { headers, params: { ledger: 302 } });
            setSupplier(response.data);
        } catch (error) {
            errorAlert("Gabim në kërkesë:", error);
            if (error.response && error.response.data && error.response.data.errorMessage) {
                errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
            } else if (error.message) {
                errorAlert(`Gabim: ${error.message} `);
            } else {
                errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
            }
        }
    };

    useEffect(() => {
        fetchSupplier();
    }, [])

    return (
        <div className='KartelaKlientit__Container'>
            {/* <div style={{ display: "flex", flexDirection: "column", marginTop: "20%", paddingLeft: "40%", width: "100%" }}> */}
            {
                openDetails ?
                    <SupplierDetails nui={nui} accountID={supplierID} accName={accName} />
                    :
                    <div className="KartelaKlientit__Container__FirstDiv">
                        <div className='KartelaKlientit__Container__FirstDiv__Input'>
                            <Autocomplete
                                {...defaultPropsSupplier}
                                id="include-input-in-list"
                                className='KartelaKlientit__Container__FirstDiv__Input__AutoComplete'
                                includeInputInList
                                value={accField}
                                onChange={handleAutocompleteChangeSupplier}
                                isOptionEqualToValue={(option, value) => option.AccountID === value.AccountID} // Shto funksionin isOptionEqualToValue
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        // style={{ width: "55% " }}
                                        className="KartelaKlientit__Container__TextField"
                                        label="Kerko Furnitorin"
                                    />
                                )}
                            />
                        </div>
                        <div className='KartelaKlientit__Container__FirstDiv__Button'>
                            <button className="button-68" variant="contained" onClick={() => showCard()}><FaSearch /> Shfaq Kartelen</button>
                        </div>
                    </div>
            }
            {/* </div> */}
        </div>
    );
};
